<template>
  <div>
    <el-card>
      <detail-form :mrpPackagePlanCode="params.code" />
      <div class="side-frame-danger group-title">
        {{ $l('tips_title_package_plan_detail') || '面料计划明细' }}
      </div>
      <detail-table :mrpPackagePlanCode="params.code" />
    </el-card>
  </div>
</template>
<script>
import DetailForm from './detail-form/index.vue'
import DetailTable from './detail-table/index.vue'
export default {
  name: 'plan-planPackage-detail',
  components: {
    DetailForm,
    DetailTable,
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
}
</script>
